import React from 'react';
import { Arrow } from 'react-konva';
import withMouseEvent from '../../hoc/withMouseEvent';

const ArrowLine = React.forwardRef(({ attrs }, ref) => {
  return (<Arrow {...attrs} ref={ref} />);
});

export default withMouseEvent(ArrowLine);